import { c as _c } from "react/compiler-runtime";
import { LazyImage } from "@website/ui/lazy-image";
import { useListItem } from "@website/ui/list-item/list-item.hook";
import styles from "@website/ui/list-item/list-item.module.scss";
import { ListItemPropertiesType } from "@website/ui/list-item/list-item.types";
import { FC } from "react";
export const ListItem: FC<ListItemPropertiesType> = properties => {
  const $ = _c(42);
  const {
    className,
    EndAction,
    EndIcon,
    image,
    Meta,
    overline,
    role,
    size: t0,
    subtitle,
    StartAction,
    StartIcon,
    title,
    isCollapsed,
    disabled,
    "aria-disabled": ariaDisabled
  } = properties;
  const size = t0 === undefined ? "medium" : t0;
  const {
    rootProps
  } = useListItem(properties);
  let t1;
  if ($[0] !== image || $[1] !== title) {
    t1 = image && <div className="flex-[0_0_64px]"><LazyImage alt={typeof title === "string" ? title : ""} src={image} /></div>;
    $[0] = image;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== StartAction) {
    t2 = StartAction && <div className={styles["start-action"]}>{StartAction}</div>;
    $[3] = StartAction;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== StartIcon) {
    t3 = StartIcon && <div className={styles.icon}>{StartIcon}</div>;
    $[5] = StartIcon;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `flex-1 whitespace-nowrap transition-opacity duration-300 ${isCollapsed ? "opacity-0" : "opacity-100 delay-200"}`;
  let t5;
  if ($[7] !== overline) {
    t5 = overline && <div className={styles.overline}>{overline}</div>;
    $[7] = overline;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== ariaDisabled || $[10] !== disabled || $[11] !== title) {
    t6 = title && <div className={`${styles.title} ${disabled || ariaDisabled ? styles.disabled : ""}`}>{title}</div>;
    $[9] = ariaDisabled;
    $[10] = disabled;
    $[11] = title;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== ariaDisabled || $[14] !== disabled || $[15] !== subtitle) {
    t7 = subtitle && <div className={`${styles.subtitle} ${disabled || ariaDisabled ? styles.disabled : ""}`}>{subtitle}</div>;
    $[13] = ariaDisabled;
    $[14] = disabled;
    $[15] = subtitle;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = <div className={t4}>{t5}{t6}{t7}</div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== Meta) {
    t9 = Meta && <div className={styles.meta}>{Meta}</div>;
    $[22] = Meta;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== EndIcon) {
    t10 = EndIcon && <div className={styles.icon}>{EndIcon}</div>;
    $[24] = EndIcon;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== EndAction) {
    t11 = EndAction && <div className={styles["end-action"]}>{EndAction}</div>;
    $[26] = EndAction;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t1 || $[29] !== t10 || $[30] !== t11 || $[31] !== t2 || $[32] !== t3 || $[33] !== t8 || $[34] !== t9) {
    t12 = <>{t1}{t2}{t3}{t8}{t9}{t10}{t11}</>;
    $[28] = t1;
    $[29] = t10;
    $[30] = t11;
    $[31] = t2;
    $[32] = t3;
    $[33] = t8;
    $[34] = t9;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  const inside = t12;
  const Tag = role === "link" ? "a" : role === "button" ? "button" : "div";
  const roleProperties = role === "link" ? rootProps.link : role === "button" ? rootProps.button : rootProps.default;
  const t13 = `${styles["list-item"]} ${styles[size]} ${className ?? ""} ${isCollapsed && image ? "px-2" : "px-6"}`;
  let t14;
  if ($[36] !== Tag || $[37] !== ariaDisabled || $[38] !== inside || $[39] !== roleProperties || $[40] !== t13) {
    t14 = <Tag aria-disabled={ariaDisabled} {...roleProperties} className={t13}>{inside}</Tag>;
    $[36] = Tag;
    $[37] = ariaDisabled;
    $[38] = inside;
    $[39] = roleProperties;
    $[40] = t13;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  return t14;
};